module.exports = __webpack_public_path__ + "static/img/doctor.26207900.jpg";